import * as React from 'react'
import { cn } from '@/lib/utils'

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  /** Marks the field invalid for assistive technology and applies the error styling. */
  invalid?: boolean
}

/**
 * The multi-line partner to {@link Input}.
 *
 * <p>Five screens had each written their own `<textarea>` with the same six classes, and they
 * had already drifted: two had no focus ring and one used a different border colour. Reasons,
 * notes and instructions are the fields people write the most in, and they were the least
 * consistent controls in the product.
 */
export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, rows = 3, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid || undefined}
      className={cn(
        'flex w-full rounded-[var(--radius-control)] border border-[var(--color-border)] bg-[var(--color-card)] px-3 py-2 text-sm text-[var(--color-heading)]',
        'placeholder:text-[var(--color-muted)]',
        'focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-[var(--color-primary)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        invalid && 'border-[var(--color-danger)]',
        className,
      )}
      {...props}
    />
  ),
)
Textarea.displayName = 'Textarea'
